<template>
  <v-container fluid>
    <h1>Vitrine</h1>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title style="background-color:#272727;">
            Tela inicial app
            <v-btn absolute right color="primary" @click="save">
              Salvar
            </v-btn>
          </v-card-title>
          <v-row
            justify="center"
            style="height:75vh; overflow: hidden; overflow-y:auto;"
          >
            <draggable
              v-model="showcases"
              draggable=".item"
              class="row wrap justify-space-around"
              @end="onEnd"
            >
              <v-col
                cols="6"
                v-for="product in showcases"
                :key="product.ean1"
                align="center"
                class="item"
              >
                <v-col>
                  <v-col class="subtitle pa-0">{{ product.name }}</v-col>
                  <v-col class="caption pa-0">{{ product.id }}</v-col>
                </v-col>
                <v-col class="pa-0" height="125">
                  <v-card height="125" width="126" color="grey">
                    <v-img
                      :src="
                        `https://app.applysys.com.br/img/produtos/webp/${product.ean1}.webp`
                      "
                      max-height="125"
                      contain
                    />
                  </v-card>
                </v-col>
              </v-col>
            </draggable>
          </v-row>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-col>
            <v-row>
              <v-autocomplete
                placeholder="Rede"
                v-model="drugstores"
                color="white"
                hide-no-data
                hide-selected
                :items="companies"
                item-text="name"
                item-value="drugstores"
                label="Buscar Rede"
                prepend-icon="mdi-database-search"
                class="mr-8"
                clearable
              >
              </v-autocomplete>
            </v-row>
            <v-row>
              <v-autocomplete
                placeholder="Farmácia"
                v-model="store"
                color="white"
                hide-no-data
                hide-selected
                :items="drugstores"
                item-text="name"
                item-value="id"
                label="Buscar farmácia"
                prepend-icon="mdi-database-search"
                return-object
                class="mr-8"
                clearable
              >
              </v-autocomplete>
            </v-row>
            <v-row>
              <v-autocomplete
                placeholder="EAN do produto"
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                color="white"
                item-text="name"
                item-value="id"
                label="Buscar produto"
                prepend-icon="mdi-database-search"
                class="mr-8"
                clearable
                hide-no-data
                hide-selected
              >
              </v-autocomplete>
            </v-row>
            <v-row>
              <v-col
                v-for="product in preview"
                :key="product.id"
                align="center"
                class="item"
              >
                <v-col class="pa-0" height="125">
                  <v-card height="125" width="126" color="grey">
                    <v-img
                      :src="
                        `https://app.applysys.com.br/img/produtos/webp/${product.ean1}.webp`
                      "
                      max-height="125"
                      contain
                    />
                    <v-btn
                      @click="addProductToShowCase(product)"
                      color="green"
                      dark
                      small
                      absolute
                      top
                      right
                      fab
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col class="subtitle pa-0">{{ product.name }}</v-col>
                <v-col class="caption pa-0">{{ product.ean1 }}</v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
      <!-- <v-col>
        <v-virtual-scroll :items="pricesAll" height="600" :item-height="50">
          <template v-slot="{ item }">
            <v-list-item>
              {{ item.product.name }}
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import {
  GetShowCases,
  GetProductByEan,
  GetCompaniesAndDrugstores,
  UpdatePriceOrder
} from "../../graphql/showcase.graphql";
//import gql from "graphql-tag";
import _ from "lodash";
export default {
  name: "ShowCase",
  data() {
    return {
      descriptionLimit: 60,
      items: [],
      isLoading: false,
      model: null,
      search: null,
      prices: [],
      drugstores: null,
      preview: null,
      store: null,
      ean: null
    };
  },
  components: {
    draggable
  },
  apollo: {
    showcases: {
      prefetch: true,
      query: GetShowCases,
      variables: {
        company: 1
      }
    },
    companies: {
      query: GetCompaniesAndDrugstores
    }
  },
  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    }
  },

  watch: {
    search(val) {
      // Items have already been loaded
      //if (this.items.length > 0) return;

      // Items have already been requested
      //if (this.isLoading) return;

      this.isLoading = true;

      if (val !== null && val.length > 4)
        this.$apollo
          .query({
            query: GetProductByEan,
            variables: { ean: `${val}%` }
          })
          .then(async data => {
            this.searchItems(data.data.products);
            this.isLoading = false;
          });
    }
  },
  methods: {
    onEnd(e) {
      console.log(e);
      // this.$apollo.mutate({
      //   mutation: ChangeOrderPricesFront,
      //   variables: {
      //     id: this.prices[e.oldIndex].id,
      //     order: e.newIndex
      //   }
      // });
    },
    async searchItems(items) {
      //console.log(Object.values(items));
      this.preview = await items;
    },
    addProductToShowCase(product) {
      //debugger;
      this.showcases.push(product);
    },
    save() {
      let dr = [];
      if (this.store === null) dr = this.drugstores;
      else dr.push(this.store);

      _.map(dr, drugstore => {
        this.showcases.map((product, index) => {
          this.$apollo.mutate({
            mutation: UpdatePriceOrder,
            variables: {
              order: index,
              id_drugstore: drugstore.id,
              id_product: product.id
            }
          });
        });
      });
    }
  }
};
</script>

<style></style>
